import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { StageDReviewApplication } from '../../models/classes/stage-d/Review-Application.class'
import { BASEURL_POLYMER, SUB_PATH_BASIC } from '../../utils/api'
import { StructureStatusEnum } from '../../models/enum/structure-status.enum'
import config from '../../config'
interface QueryParams {
  application_uuid: string
  uinfin: string
  stage: "D1" | "D2" | "D3" | "D4"
  structure?: StructureStatusEnum
  singpass_token: string
}

export const stageDApi = createApi({
  reducerPath: 'stageDApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASEURL_POLYMER, 
  prepareHeaders:(headers,{getState})=>{
    headers.set("Access-Control-Request-Method", "GET");
    headers.set("X-Content-Type-Options", "nosniff");
    headers.set("x-api-key", `${config.xApiKey}`);
  }}),
  endpoints: (builder) => ({
    getStageD1Obj: builder.query<StageDReviewApplication, QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "GET",
        url:`${SUB_PATH_BASIC}/application/getApplicationUpdate/${queryParams.application_uuid}`,
        headers: {
          uinfin: queryParams.uinfin,
          Authorization: `Bearer ${queryParams.singpass_token}`
        },
      }),
      transformResponse:(response: StageDReviewApplication, meta, arg)=>{
        let formatted_response = new StageDReviewApplication(response);
        if(arg.stage === "D1" && formatted_response.stageD1ProcessFolders && formatted_response.json){
          formatted_response.stageD1ProcessFolders();
          return formatted_response.json();
        }
        
        if(arg.stage === "D2" && formatted_response.stageD2ProcessFolders && formatted_response.json){
          formatted_response.stageD2ProcessFolders();
          return formatted_response.json();
        }

        if(arg.stage === "D4" && formatted_response.stageD4ProcessFolders && arg.structure && formatted_response.json){
          formatted_response.stageD4ProcessFolders(arg.structure);
          return formatted_response.json();
        }
      
        return response
      },
      keepUnusedDataFor:1,
    }),
  }),
})

export const { useGetStageD1ObjQuery } = stageDApi

